import { useRef, useEffect } from 'react';
// ---- external imports ----

function useEventListener(element, eventName, handler, options = {}) {
	const savedHandler = useRef();
	const { capture, passive, once } = options;

	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(() => {
		const isSupported = element && element.addEventListener;

		if (!isSupported) {
			console.warn('addEventListener is not supported for element',
				element);
			return;
		}

		const eventListener = (event) => savedHandler.current(event);
		element.addEventListener(eventName, eventListener, { capture, passive, once });

		return () => {
			element.removeEventListener(eventName, eventListener);
		};
	}, [eventName, element, capture, passive, once]);
};

export default useEventListener;
